import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export class EventDetail extends Component {
  render() {
    const { event, projectId, version } = this.props;
    const { eventTitle, uuid } = event;
    return (
      <Fragment>
        <Link
          to={`/events/${version}/v/${projectId}/event/${uuid}`}
          className={`list-group-item list-group-item-action align-items-center`}
          style={{ cursor: 'pointer', float: 'left' }}
        >
          <i className="gjs-caret-icon wb webconnect-diagram-2-fill"></i>&nbsp;{eventTitle}
        </Link>
      </Fragment>
    );
  }
}

EventDetail.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventDetail;
